import {useTranslate} from '@local/hooks'
import {Button} from '@local/ui/components'
import {cx} from '@local/utils/cx'
import React, {ForwardedRef, forwardRef} from 'react'

export interface LayoutSwitchProps {
	className?: string
	activeLeft: boolean
	activeRight: boolean
	onClickLeft: () => void
	onClickRight: () => void
}

export const LayoutSwitch = forwardRef(
	(
		{className, activeLeft, onClickLeft, activeRight, onClickRight}: LayoutSwitchProps,
		ref: ForwardedRef<HTMLDivElement>,
	) => {
		const locale = useTranslate()
		return (
			<div ref={ref} className={cx('lg:fixed lg:top-20 lg:margin-right-1 lg:z-4 lg-max:mb-8 lg-max:margin-mx-1', className)}>
				<div className='relative bg-white rounded-xs p-2'>
					<div className={cx(
						'absolute w-[calc(50%-0.25rem)] bottom-2 top-2 bg-black rounded-xxs',
						'transition-transform transform-gpu duration-300 ease-quart-out',
						activeLeft && 'translate-x-0',
						activeRight && 'translate-x-[calc(100%+0.25rem)]',
					)} />
					<Button
						small
						className={cx(
							'lg-max:w-1/2 text-center cursor-pointer',
							'h-40 px-21 py-0 inline-flex justify-center items-center uppercase lg:text-9 tracking-doubleWide lg:tracking-widest font-semibold',
							'transition-colors duration-300 ease-quart-out',
							activeLeft ? 'text-white' : 'text-grey-2',
						)}
						onClick={onClickLeft}
						active={activeLeft}>
						{locale('Grid')}
					</Button>
					<Button
						small
						className={cx(
							'lg-max:w-1/2 text-center cursor-pointer',
							'h-40 px-21 py-0 inline-flex justify-center items-center uppercase lg:text-9 tracking-doubleWide lg:tracking-widest font-semibold',
							'transition-colors duration-300 ease-quart-out',
							activeRight ? 'text-white' : 'text-grey-2',
						)}
						onClick={onClickRight}
						active={activeRight}>
						{locale('List')}
					</Button>
				</div>
			</div>
		)
	},
)
